export default {
  BusinessReportSaleAnalysis: {
    orderTime: '下单时间',
    channel: '渠道',
    orderDate: '日期',
    orderCount: '新增订单数',
    orderItemCount: '新增订单商品数',
    orderAmount: '新增订单销售金额',
    reverseCount: '新增退款单数',
    reverseItemCount: '新增退款商品数',
    reverseAmount: '新增退款金额',
    sendOrderCount: '当日发货订单数',
    sendOrderItemCount: '当日发货商品数',
    sendOrderAmount: '发货商品金额',
  }
};
